// extracted by mini-css-extract-plugin
export default {"root":"T1w3aF","eventTitle":"loYOTR"};